import { apiClient } from '../axios-instance';

export interface PlatformSetting {
  id: number;
  key: string;
  value: any;
  type: string;
  group: string;
  label: string;
  description: string;
}

export type GroupedSettings = Record<string, PlatformSetting[]>;

export const platformSettingsService = {
  getSettings: async () => {
    const response = await apiClient.get<{ success: boolean; data: GroupedSettings }>('/admin/settings');
    return response.data;
  },

  updateSettings: async (settings: Record<string, any>) => {
    const response = await apiClient.post<{ success: boolean; message: string }>('/admin/settings', { settings });
    return response.data;
  },
};
